import styled from 'styled-components';

export const CallToAction = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
